import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_transaction_table = _resolveComponent("transaction-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesLoaded.length + 1, (index) => {
      return (_openBlock(), _createBlock(_component_v_container, {
        id: 'row-' + index,
        key: index
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    type: "file",
                    onChange: ($event: any) => (_ctx.onFileChange($event, index - 1)),
                    disabled: 
            !_ctx.selectedBank[index - 1] || _ctx.filesLoaded[index - 1] !== undefined
          ,
                    accept: "csv, xlxs",
                    id: 'input-' + index
                  }, null, 8, ["onChange", "disabled", "id"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    items: ['Chase', 'Amex', 'Discover'],
                    label: "Select Bank",
                    solo: "",
                    modelValue: _ctx.selectedBank[index - 1],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.selectedBank[index - 1]) = $event),
                    disabled: _ctx.filesLoaded[index - 1] !== undefined
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  (_ctx.filesLoaded[index - 1])
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        onClick: ($event: any) => (_ctx.clearFile(index - 1)),
                        color: "primary",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode(" Clear ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["id"]))
    }), 128)),
    (_ctx.rawTableData.length > 0)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          onClick: _ctx.resetAll,
          color: "primary",
          elevation: "2"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Reset", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.rawTableData.length > 0)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          onClick: _ctx.uploadData,
          color: "primary",
          elevation: "2"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Upload", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_transaction_table, {
      "table-data": _ctx.rawTableData,
      "is-editable": false
    }, null, 8, ["table-data"])
  ], 64))
}